import Platform from 'platform';
import compareVersion from 'compare-version';

export function getInternetExplorerVersion() {
    let rv = -1;
    if (navigator.appName === 'Microsoft Internet Explorer') {
        const ua = navigator.userAgent;
        const re = new RegExp('MSIE ([0-9]{1,}[.0-9]{0,})');
        if (re.exec(ua) != null) rv = parseFloat(RegExp.$1);
    } else if (navigator.appName === 'Netscape') {
        const ua = navigator.userAgent;
        const re = new RegExp('Trident/.*rv:([0-9]{1,}[.0-9]{0,})');
        if (re.exec(ua) != null) rv = parseFloat(RegExp.$1);
    }
    return rv;
}

export function isSupportedBrowser() {
    return compareVersion(Platform.version, getBrowserInfo(Platform.name).minVersion) !== -1;
}

export function getBrowserInfo(browserName) {
    switch (browserName) {
        case 'Chrome':
            return {
                device: Platform.product,
                iconName: 'chrome',
                linkDownload: 'https://www.google.com/chrome/browser/desktop/',
                minVersion: '42',
                name: browserName
            };
        case 'Chrome Mobile':
            return {
                device: Platform.product,
                iconName: 'chrome',
                linkDownload: 'https://www.google.com/chrome/browser/mobile/',
                minVersion: '42',
                name: browserName
            };
        case 'Safari':
            return {
                device: Platform.product,
                iconName: 'safari',
                linkDownload: 'https://itunes.apple.com/it/app/os-x-yosemite/id915041082?mt=12',
                minVersion: '10',
                name: browserName
            };
        case 'Firefox':
            return {
                device: Platform.product,
                iconName: 'firefox',
                linkDownload: 'https://www.mozilla.org/it/firefox/new/',
                minVersion: '42',
                name: browserName
            };
        case 'IE':
            return {
                device: Platform.product,
                iconName: 'chrome',
                linkDownload: 'https://www.google.com/chrome/browser/desktop/',
                //linkDownload: 'http://windows.microsoft.com/it-it/internet-explorer/download-ie',
                minVersion: '1000', //ie is unsupported
                name: browserName
            };
        case 'Opera':
            return {
                device: Platform.product,
                iconName: 'chrome',
                linkDownload: 'https://www.google.com/chrome/browser/desktop/',
                //linkDownload: 'http://www.opera.com/it?utm_medium=roc&utm_source=team23_de&utm_campaign=browser-update_org',
                minVersion: '52',
                name: browserName
            };
        case 'Android Web':
            return {
                device: Platform.product,
                iconName: 'android_web',
                linkDownload: 'link',
                minVersion: '1',
                name: browserName
            };
        default:
            return {
                device: Platform.product,
                iconName: 'android_browser',
                linkDownload: '',
                name: browserName
            };
    }
}
